<template>
  <div v-for="wagon in wagons" :key="wagon" class="m-5">
    <div class="px-6 py-4 flex gap-5 justify-left overflow-auto bg-gray-200 border
    border-gray-300 rounded-lg shadow-lg">
      <CardSection
        class="bg-gray-50"
        v-for="section in wagon"
        :key="section.type"
        :sectionIndex="section.section_id"
        :section="section"
        @update-value="updateSectionValue"
      />
    </div>
    <div class="flex">
      <img :src='wagonLeftSide' class="w-7 h-7" alt="Wagon left side"/>
      <img :src='wagonCenter' class="w-full h-7" alt="Wagon center"/>
      <img :src='wagonRightSide' class="w-7 h-7" alt="Wagon right side"/>
    </div>
  </div>
</template>

<script>
import useTransitStore from '@/stores/TransitStore';
import wagonLeftSide from '@/assets/img/wagon_left_side.png';
import wagonRightSide from '@/assets/img/wagon_right_side.png';
import wagonCenter from '@/assets/img/wagon_center.png';
import CardSection from './CardSection.vue';

export default {
  name: 'WagonSection',
  props: ['sections', 'transit_id'],
  emits: ['transit-edited'],
  components: {
    CardSection,
  },
  data() {
    return {
      wagons: [],
      sectionsMap: new Map(),
      wagonLeftSide,
      wagonRightSide,
      wagonCenter,
      transitStore: useTransitStore(),
    };
  },
  methods: {
    splitWagons() {
      this.sectionsMap.clear();
      this.wagons = [];
      let currentWagon = [];
      this.sections.forEach((section) => {
        if (section.type === 'video_frame_position') {
          return;
        }
        if (section.type !== 'universalwagon') {
          console.error('Train Transit Json misformed. Should only contain wagon sections!', section.type);
          return;
        }
        currentWagon.push(section);
        this.sectionsMap.set(section.section_id, section);
        section.childMetaObjects.forEach((wagonSection) => {
          currentWagon.push(wagonSection);
          this.sectionsMap.set(wagonSection.section_id, wagonSection);
        });
        this.wagons.push(currentWagon);
        currentWagon = [];
      });
    },
    async updateSectionValue({ index, updatedValue, sectionIndex }) {
      const currentSection = this.sectionsMap.get(sectionIndex).values[index];
      if (currentSection.value === updatedValue) return;
      let putResult = false;
      if (currentSection.value_type === 'reading') {
        putResult = await this.transitStore.putReadingValue({ readingId: currentSection.db_id, newValue: updatedValue });
      } else {
        putResult = await this.transitStore.putClassificationValue({ classificationId: currentSection.db_id, newValue: updatedValue });
      }
      if (putResult) {
        currentSection.edited = true;
        currentSection.value = updatedValue;
        this.$emit('transit-edited', { transitId: this.transit_id });
        this.emitter.emit('show-toast', { toastType: 'info', toastText: this.$t('transitCard.successfulEdit') });
      } else {
        const replaceValue = currentSection.value;
        currentSection.value = replaceValue;
        this.emitter.emit('show-toast', { toastType: 'error', toastText: this.$t('transitCard.errorOnEdit') });
      }
    },
  },
  beforeMount() {
    this.splitWagons();
  },
};
</script>
